import React, { useState, useEffect } from "react";
import Select from "react-select";
import { connect } from "react-redux";
import { useParams } from "react-router";
import { Button, Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";

import {
  COLORS,
  emptyString,
  errorMessages,
  loginConstants,
  toastTypes,
  validationConstant,
} from "../../../../constants";
import { managersConstants } from "../../../../views/group-screens/constants";
import { inputFieldNames } from "../../../../views/shared-screens/constants";
import {
  Option,
  useSpinner,
  customToast,
  ValueContainer,
  loadingIndicator,
} from "../../../../shared";
import { managersActions } from "../../../../views/group-screens/redux/actions";
import { getItemFromStorage } from "../../../../system";

const { IS_VALID } = validationConstant;
const { BRAND_LOCATIONS_MANAGER } = inputFieldNames;

//Customer styles for react select
const styleReactSelect = (error) => {
  return {
    control: (styles) => ({
      ...styles,
      borderRadius: "6px",
      minHeight: "2.3rem",
      borderColor: error ? COLORS.SCARLET : COLORS.ASH_GREY,
      "&:hover": {
        borderColor: error ? COLORS.SCARLET : COLORS.ASH_GREY,
      },
      boxShadow: "none",
    }),
    //Changing default style of options in react select
    option: (baseStyles, state) => ({
      ...baseStyles,
      backgroundColor: state.isSelected ? "transparent" : emptyString,
      color: "black",
    }),
  };
};

const AddManagerModal = (props) => {
  const {
    row,
    brandId,
    groupId,
    editMode,
    brandData,
    queryString,
    allLocations,
    getBrandlocations,
    updateManagerDetails,
  } = props;

  const {
    reset,
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  let userRole = getItemFromStorage(loginConstants.ROLE);

  const { groupId: paramGroupId } = useParams();

  const [rowData, setRowData] = useState(row);
  const [isValid, setIsValid] = useState(true);
  const [checkedItems, setCheckedItems] = useState(
    rowData?.stores?.length > 0 ? rowData?.stores.map((loc) => loc.id) : []
  );
  const [validate, setValidate] = useState(emptyString);
  const [selectedLocations, setSelectedLocations] = useState(
    rowData?.stores?.length > 0 ? rowData?.stores : []
  );
  const [locations, setLocations] = useState([]);

  //Handle Change function to set rowData and checkedItems
  const handleChange = (e) => {
    const { name, value } = e.target || e;
    if (name === BRAND_LOCATIONS_MANAGER) {
      setCheckedItems(value);
    }
    setRowData({ ...rowData, [name]: value });
  };

  //OnSubmit function to submit all the data on submission
  const onSubmit = (data) => {
    let nameLength = data.name.length;
    let nameValid = nameLength > 0 && nameLength < 200;
    let areItemsValid = checkedItems.length > 0;

    setValidate(areItemsValid ? emptyString : IS_VALID);
    setIsValid(!!areItemsValid);

    if (nameValid && areItemsValid && (groupId || editMode)) {
      let dataToSend = {
        ...data,
        name: rowData?.name,
        brandId: brandData?.id || brandId,
        groupId: groupId || rowData.groupId,
        storeIds: checkedItems,
      };

      if (editMode) {
        // Update group
        updateManagerDetails(
          { ...dataToSend, id: rowData.id },
          queryString,
          paramGroupId,
          userRole
        );
      }
      resetState();
      props.onClose();
    }
    if (!groupId && !editMode) {
      customToast(errorMessages.PLEASE_SELECT_FRANCHISE, toastTypes.ERROR);
    }
  };

  //Function to reset states
  const resetState = () => {
    reset();
    setRowData({});
    setIsValid(true);
    setCheckedItems([]);
    setValidate(emptyString);
    setSelectedLocations([]);
  };

  //Set locations dropdown options and remove duplication from locations
  const setBrandLocationsList = (rowDataLocation, backendLocations) => {
    let locationsArray = [...rowDataLocation, ...backendLocations];
    return [...new Map(locationsArray.map((m) => [m.id, m])).values()];
  };

  // Show loading while a request is running.
  const spinner = useSpinner();

  // Validation on checked items
  useEffect(() => {
    if (!isValid) {
      if (checkedItems.length !== 0) {
        setValidate(emptyString);
      } else {
        setValidate(IS_VALID);
      }
    }
    // eslint-disable-next-line
  }, [checkedItems]);

  useEffect(() => {
    if (groupId) {
      getBrandlocations(groupId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Set locations after render and api call
  useEffect(() => {
    if (allLocations) {
      setLocations(allLocations);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allLocations]);

  return (
    <Modal
      show={props.show}
      onHide={props.onClose}
      animation={props.animate}
      size={props.ModalSize}
      className="react-survey-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {!editMode ? props.AddManagerText : props.UpdateManagerText}
        </Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          <div className="row">
            <div className="col-12">
              <div className="form-group mb-3">
                <label htmlFor="name" className="mt-2 col-sm-3 fw-bold">
                  Brand Name:
                </label>
                <span className="col-sm-3">{brandData?.name}</span>
              </div>
              <div className="form-group mb-3 fw-bold">
                <label className="mb-1" htmlFor="name">
                  Manager Name:
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.name ? "is-invalid" : emptyString
                  }`}
                  name="name"
                  value={rowData?.name}
                  placeholder="Enter name"
                  {...register("name", {
                    required: true,
                    maxLength: "200",
                    minLength: "1",
                    onChange: (e) => handleChange(e),
                  })}
                />
              </div>
              <div className="form-group mb-3 ">
                <h6 className="fw-bold" htmlFor="brandLocationId">
                  Stores:
                </h6>
                <Controller
                  name="Locations"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      value={selectedLocations}
                      closeMenuOnSelect={false}
                      options={setBrandLocationsList(
                        rowData?.stores || [],
                        locations
                      )}
                      components={{
                        Option,
                        ValueContainer: ValueContainer,
                        IndicatorSeparator: () => null,
                        LoadingIndicator: loadingIndicator,
                      }}
                      isMulti
                      hideSelectedOptions={false}
                      maxMenuHeight={200}
                      getOptionValue={(option) => option.id}
                      getOptionLabel={(option) => option.name}
                      onChange={(e) => {
                        let obj = {
                          name: BRAND_LOCATIONS_MANAGER,
                          value: e.map((loc) => loc.id),
                          checked: true,
                        };
                        handleChange(obj);
                        setSelectedLocations(e);
                      }}
                      placeholder="Select Stores"
                      isSearchable={true}
                      styles={styleReactSelect(validate)}
                      className="w-100 font-14-px text-secondary"
                      id="Locations"
                      isDisabled={spinner(managersConstants.MANAGERS_DATA)}
                      isLoading={spinner(managersConstants.MANAGERS_DATA)}
                    />
                  )}
                  rules={{
                    required: validate,
                  }}
                />
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant={props.SubmitButtonVariant}
            className={props.SubmitButtonClasses}
            style={props.SubmitButtonStyle}
            type="submit"
          >
            {!editMode ? props.SubmitButtonText : props.UpdateButtonText}
          </Button>
          <Button
            variant={props.CancelButtonVariant}
            className={props.CancelButtonClasses}
            style={props.CancelButtonStyle}
            onClick={props.onClose}
          >
            {props.CancelButtonText}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  brandData: state.storesReducer.store,
  allLocations: state.managersReducer.allLocations?.data,
});

const mapDispatchToProps = (dispatch) => ({
  updateManagerDetails: (body, gridState, groupId, userRole) =>
    dispatch(
      managersActions.updateManagerDetails(body, gridState, groupId, userRole)
    ),
  getBrandlocations: (groupId) =>
    dispatch(managersActions.getBrandlocations(groupId)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AddManagerModal);
